module.exports = __webpack_public_path__ + "img/tuan3-1.ef21a3cf.png";